import { compose, withProps } from 'recompose';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import get from 'lodash/get';

import { selectProgressCareUser } from '../../../redux/appointmentForm/selectors';

const mapStateToProps = state => ({
  careUser: selectProgressCareUser(state),
});

export default compose(
  injectIntl,
  connect(mapStateToProps),
  withProps(({ careUser }) => ({
    subtitle: {
      id: 'appointments.form.step2.subTitle',
      state: { user: get(careUser, 'displayableName') },
    },
  })),
);



// WEBPACK FOOTER //
// ./src/components/AppointmentForm/hocs/withCareUserSubtitle.js